var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKostka(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 950,
    height: 952,
    viewBox: "0 0 950 952",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "rect18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M214.4 22.5001C219.7 6.00012 237.4 -3.29988 254 2.00012L387 44.2001C403.5 49.5001 412.8 67.2001 407.5 83.8001L365.3 216.8C360 233.3 342.3 242.6 325.7 237.3L192.7 195.1C176.2 189.8 166.9 172.1 172.2 155.5L214.4 22.5001Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "rect20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M484.6 108.3C489.9 91.8002 507.6 82.5002 524.2 87.8002L657.2 130C673.7 135.3 683 153 677.7 169.6L635.5 302.6C630.2 319.1 612.5 328.4 595.9 323.1L462.9 280.9C446.4 275.6 437.1 257.9 442.4 241.3L484.6 108.3Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "rect22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M755 194.1C760.3 177.6 778 168.3 794.6 173.6L927.6 215.8C944.1 221.1 953.4 238.8 948.1 255.4L905.9 388.4C900.6 404.9 882.9 414.2 866.3 408.9L733.1 366.7C716.6 361.4 707.3 343.7 712.6 327.1L755 194.1Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "rect24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M129.5 293C134.8 276.5 152.5 267.2 169.1 272.5L302.1 314.7C318.6 320 327.9 337.7 322.6 354.3L280.4 487.3C275.1 503.8 257.4 513.1 240.8 507.8L107.8 465.6C91.2997 460.3 81.9997 442.6 87.2997 426L129.5 293Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "rect26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M399.9 378.8C405.2 362.3 422.9 353 439.5 358.3L572.5 400.5C589 405.8 598.3 423.5 593 440.1L550.8 573.1C545.5 589.6 527.8 598.9 511.2 593.6L378.2 551.4C361.7 546.1 352.4 528.4 357.7 511.8L399.9 378.8Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "rect28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M670.1 464.7C675.4 448.2 693.1 438.9 709.7 444.2L842.7 486.4C859.2 491.7 868.5 509.4 863.2 526L821 659C815.7 675.5 798 684.8 781.4 679.5L648.4 637.3C631.9 632 622.6 614.3 627.9 597.7L670.1 464.7Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "rect30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M44.0998 563.5C49.3998 547 67.0998 537.7 83.6998 543L216.7 585.2C233.2 590.5 242.5 608.2 237.2 624.8L195 757.8C189.7 774.3 172 783.6 155.4 778.3L22.3998 736.1C5.89978 730.8 -3.40022 713.1 1.89978 696.5L44.0998 563.5Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "rect32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M314.5 649.4C319.8 632.9 337.5 623.6 354.1 628.9L487.1 671.1C503.6 676.4 512.9 694.1 507.6 710.7L465.4 843.7C460.1 860.2 442.4 869.5 425.8 864.2L292.8 822C276.3 816.7 267 799 272.3 782.4L314.5 649.4Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "rect34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M584.7 735.2C590 718.7 607.7 709.4 624.3 714.7L757.3 756.9C773.8 762.2 783.1 779.9 777.8 796.5L735.6 929.5C730.3 946 712.6 955.3 696 950L563 907.8C546.5 902.5 537.2 884.8 542.5 868.2L584.7 735.2Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKostka);
export default __webpack_public_path__ + "static/media/kostka.207cc3d14f19cc90beddefac47f3030d.svg";
export { ForwardRef as ReactComponent };